module.exports = __webpack_public_path__ + "media/img/private-venue/bg-benefit-de02961842c3e6e8f514c8c1dbc3ea1d.png";